import { OnSiteVisitsAction, setAvailableOnSiteTimeSlots, setAvailableOnSiteTimeSlotsFetching, setOnSiteVisit, setOnSiteVisits, setOnSiteVisitsFetching } from './actions';
import { UIAction } from '../../ui/actions';
import { all, call, fork, put, select, take, takeLatest, delay } from 'redux-saga/effects';

import { ApiResponse } from 'apisauce';
import { HealAPI } from '../../../healApi';
import { OnSiteVisit } from './types';
import { RootState } from '../../types';

function* getOnSiteVisits(): any {
  const state: RootState = yield select((s) => s);
  yield put(setOnSiteVisitsFetching(true));
  const result = yield call(HealAPI.fetchVisits, state.ui.markets, 5000, state.ui.visitStatus, state.ui.onSiteFromDate, state.ui.onSiteToDate, true);
  // yield put(setVisitCode(''));
  yield put(setOnSiteVisits((result && result.data && result.data.results) || []));
  yield put(setOnSiteVisitsFetching(false));
}

function* getOnSiteVisit(data: { visitCode: string; refresh?: boolean }): any {
  const { visitCode, refresh } = data;
  yield put(setOnSiteVisitsFetching(true));
  const result: ApiResponse<OnSiteVisit> = yield call(HealAPI.fetchVisit, visitCode);
  yield put(setOnSiteVisit(result.data!));
  yield put(setOnSiteVisitsFetching(false));

  if (refresh) {
    yield delay(3000);
    yield fork(getOnSiteVisit, { visitCode });
  }
}

function* getOnSiteVisitsData() {
  try {
    yield all([fork(getOnSiteVisits)]);
  } catch (e: any) {
    // error handling
  }
}

export function* onSiteVisitsFlow() {
  yield takeLatest(['PAGE_DID_MOUNT/OnSiteVisits', UIAction.SET_ONSITES_FROM_DATE, UIAction.SET_ONSITES_TO_DATE, OnSiteVisitsAction.UPDATE_TIME], getOnSiteVisitsData);
}

export function* fetchOnSiteVisitFlow() {
  while (true) {
    const { data } = yield take(OnSiteVisitsAction.FETCH_ONSITE_VISIT);
    yield fork(getOnSiteVisit, data);
  }
}

function* fetchAvailableOnSiteTimeSlots(): any {
  yield put(setAvailableOnSiteTimeSlotsFetching(true));
  const state: RootState = yield select((s) => s);
  if (state.ui.visitCode) {
    const onSiteVisitCode: string = state.ui.visitCode;
    if (onSiteVisitCode) {
      const result = yield call(HealAPI.fetchAvailableOnSiteTimeSlots, onSiteVisitCode);
      if (result.data) {
        yield put(setAvailableOnSiteTimeSlots(result.data));
      }
    }
  }
  yield put(setAvailableOnSiteTimeSlotsFetching(false));
}

export function* timeSlotsForUpdateTimeFlow() {
  yield takeLatest(['PAGE_DID_MOUNT/UpdateTimeDialog'], fetchAvailableOnSiteTimeSlots);
}
